var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"pa-3",staticStyle:{"background-color":"white"}},[_c('pre',[_vm._v(_vm._s(_vm.textContent))])]),_c('div',{staticClass:"flex-1 pa-3",staticStyle:{"background":"white","border-left":"1px solid red"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }